type GetPanelWidthParams = {
  isPanelZoom: boolean;
  canvasWidth: number;
  canvasZoom: number;
};

/**
 * Returns the logical width of one panel.
 * When panel zoom is active, canvasWidth/canvasZoom already represents one panel.
 * Otherwise, it's half the full canvas logical width.
 */
export const getPanelWidth = ({ isPanelZoom, canvasWidth, canvasZoom }: GetPanelWidthParams): number =>
  isPanelZoom ? canvasWidth / canvasZoom : canvasWidth / (2 * canvasZoom);
